import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "impx-content hp3 uk-padding uk-padding-remove-horizontal bg-color-csa pattern-1" }
const _hoisted_2 = { class: "uk-container" }
const _hoisted_3 = {
  class: "uk-flex-center",
  "data-uk-grid": ""
}
const _hoisted_4 = { class: "uk-width-2-3@xl uk-width-2-3@l uk-width-3-4@m uk-width-1-1@s" }
const _hoisted_5 = {
  class: "uk-child-width-1-3@xl uk-child-width-1-2@l uk-child-width-1-2@m uk-child-width-1-2@s impx-features-list",
  "data-uk-grid": ""
}
const _hoisted_6 = { class: "uk-position-relative" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "uk-position-relative" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "uk-position-relative" }
const _hoisted_11 = ["src"]


export default /*@__PURE__*/_defineComponent({
  __name: 'HeadinDesc',
  setup(__props) {

  const showRoomImg = [
      './images/carousel/room.jpg',
      './images/carousel/room_2.jpg'
  ]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"uk-flex-center\" data-uk-grid><div class=\"uk-width-3-4@xl uk-width-3-4@l uk-width-1-1@m uk-margin-large-top impx-margin-top-small\"><div class=\"impx-intro uk-text-center uk-position-relative uk-position-z-index\"><h2 class=\"uk-margin-small-top uk-margin-small-bottom uk-heading-line line-light impx-text-white\"><span>Passer de beaux moments avec nos salles</span></h2><p class=\"impx-text-large uk-margin-remove impx-text-lighter\">Pour tous vos événements heureux et conférences nos salle Conférence et Événementielle bien équipés sont prêtes à vous accueillir .</p></div></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: showRoomImg[0],
                  alt: "conference",
                  class: "uk-border-circle img-70 img-centered img-100"
                }, null, 8, _hoisted_7),
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "impx-overlay overlay-outline light img-70 img-centered img-100" }, null, -1)),
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "impx-feature-caption" }, [
                  _createElementVNode("i", { class: "fa fa-briefcase fa-2x impx-text-white" }),
                  _createElementVNode("h4", { class: "impx-text-white impx-text-shadow" }, "Salle de Conférence")
                ], -1))
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("img", {
                  src: showRoomImg[1],
                  alt: "event",
                  class: "uk-border-circle img-70 img-centered img-100"
                }, null, 8, _hoisted_9),
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "impx-overlay overlay-outline light img-70 img-centered img-100" }, null, -1)),
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "impx-feature-caption" }, [
                  _createElementVNode("i", { class: "fa fa-bookmark fa-2x impx-text-white" }),
                  _createElementVNode("h4", { class: "impx-text-white impx-text-shadow" }, "Salle Événementielle")
                ], -1))
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("img", {
                  src: showRoomImg[1],
                  alt: "resort",
                  class: "uk-border-circle img-70 img-centered img-100"
                }, null, 8, _hoisted_11),
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "impx-overlay overlay-outline light img-70 img-centered img-100" }, null, -1)),
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "impx-feature-caption" }, [
                  _createElementVNode("i", { class: "fa fa-football-ball fa-2x impx-text-white" }),
                  _createElementVNode("h4", { class: "impx-text-white impx-text-shadow" }, "Salle de Loisir")
                ], -1))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})